import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs';
// import { ErrorCode } from '../enums/error-code.enum';
import { Const } from '../static/const';

@Injectable({
  providedIn: 'root',
})
export class BaseDataProvider {
  constructor() {}

  protected getApiUrl(path: string): string {
    return Const.connectionUrl + path;
  }

  // protected handleHttpError(error: any) {
  //   const errResponse: Error = error;
  //   if (
  //     !errResponse ||
  //     (errResponse && errResponse.name === ErrorCode.INTERNAL_ERROR)
  //   ) {
  //     console.log('Error Status: ' + ErrorCode.INTERNAL_ERROR);
  //   }
  // }
}
